define('tracking',['jquery', 'underscore', 'lib', 'event-manager', 'pulse'], function($, _, lib, eventManager, Pulse) {
    'use strict';

    var Tracking = {
        init: function() {
            Pulse.init();
        },
    };

    _.bindAll(Tracking, _.methods(Tracking));

    eventManager.once('domready', function() {
        Tracking.init();
    });
});

